import { render, staticRenderFns } from "./ReportData.vue?vue&type=template&id=905b3e02&scoped=true&"
import script from "./ReportData.vue?vue&type=script&lang=ts&"
export * from "./ReportData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b3e02",
  null
  
)

export default component.exports